const SOCIAL_ECOMM_CREATE_ACCOUNT = '/create-account';
const GTB_CHECKOUT = '/gtb-checkout';
const PUBLIC_SHOP_CHECKOUT = '/checkout';
const TESTING_CHECKOUT_V2 = '/checkout-v2';

export {
  SOCIAL_ECOMM_CREATE_ACCOUNT,
  GTB_CHECKOUT,
  PUBLIC_SHOP_CHECKOUT,
  TESTING_CHECKOUT_V2,
};
